import React from 'react';
import { Upload, CheckCircle, Trash2 } from 'lucide-react';

export default function UploadArchivosAdjuntos({ archivosAdjuntos, handleFileChange, removeFile }) {
  return (
    <div className="glass-card" style={{ background: 'rgba(255, 255, 255, 0.4)', border: '1px solid var(--border-color)', marginTop: '1.5rem' }}>
      <h4 style={{ margin: '0 0 1rem', fontSize: '1.05rem', color: 'var(--text-main)', borderBottom: '1px solid var(--border-color)', paddingBottom: '0.5rem' }}>
        Archivos de Referencia (Opcional)
      </h4>
      <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '1rem' }}>
        Si tienes una copia antigua del documento, una minuta o un plano, puedes adjuntarlo para facilitar la búsqueda.
      </p>

      <div
        style={{
          border: archivosAdjuntos.length > 0 ? '2px solid var(--success)' : '2px dashed var(--border-color)',
          borderRadius: '16px', padding: '2rem', textAlign: 'center',
          background: archivosAdjuntos.length > 0 ? 'var(--success-bg)' : 'rgba(var(--primary-rgb), 0.02)',
          transition: 'all 0.3s ease', position: 'relative'
        }}
      >
        <input
          type="file"
          onChange={handleFileChange}
          style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer', zIndex: 5 }}
          accept=".pdf,.jpg,.jpeg,.png"
          multiple
        />

        {archivosAdjuntos.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.8rem', position: 'relative', zIndex: 10 }}>
            <CheckCircle size={40} style={{ color: 'var(--success)' }} />
            <span style={{ fontWeight: 600, color: 'var(--text-main)' }}>
              {archivosAdjuntos.length} {archivosAdjuntos.length === 1 ? 'archivo adjunto' : 'archivos adjuntos'}
            </span>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'center', width: '100%', maxWidth: '300px' }}>
              {archivosAdjuntos.map((file, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', background: '#fff', padding: '4px 8px', borderRadius: '4px', border: '1px solid var(--border-color)' }}>
                  <span style={{ fontSize: '0.8rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '200px' }}>{file.name}</span>
                  <button
                    className="btn btn-link btn-sm"
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); removeFile(i); }}
                    style={{ color: 'var(--danger)', padding: 0 }}
                    title="Quitar"
                  >
                    <Trash2 size={14} />
                  </button>
                </div>
              ))}
            </div>
            {archivosAdjuntos.length < 5 && (
              <div style={{ marginTop: '0.5rem', color: 'var(--primary)', fontWeight: 500, fontSize: '0.85rem' }}>
                + Haz clic o arrastra para añadir más (Máx. 5)
              </div>
            )}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
            <Upload size={32} style={{ color: 'var(--text-muted)' }} />
            <span style={{ fontWeight: 600, color: 'var(--text-main)' }}>Haz clic o arrastra tus archivos aquí</span>
            <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>PDF, JPG, PNG (Máx 10MB)</span>
          </div>
        )}
      </div>
    </div>
  );
}
